import React, { Component } from 'react';
import { connect } from "react-redux";

import {LoadingIcon} from '../../../Common/Loading_Icon';
import { debounce } from "lodash";

import axios from "axios";
import moment from "moment";

import Select from 'react-select';

import { setList } from '../../../../Actions/stakeholderActions.js';
import { Trans } from 'react-i18next';

class SHUser extends Component {
    constructor(props) {    
        super(props);

        this.state = {
            shuser_details: {},
            action: "",
            loading_page: true,
            user_create: true,
            shuser_form: {user_id: ("id" in this.props.match.params ? this.props.match.params.id : null), first_name: "", last_name: "", company: null, title: null, email: null, email_confirm: null, phone: null, role: null, type: null, oem_id: null, vmh_id: null, sh_id: null},
            selected_role: null, selected_oem: null, selected_vmh: null, selected_sh: null, selected_type: null
        };

        this.submitForm = debounce(this.submitForm.bind(this), 500);
        this.updateForm = this.updateForm.bind(this);
        this.updateSelect = this.updateSelect.bind(this);
        this.loadVMHs = this.loadVMHs.bind(this);
        this.loadDivisions = this.loadDivisions.bind(this);
        this.loadTypesAndRoles = this.loadTypesAndRoles.bind(this);

    }

    componentDidMount() {
        var self = this;
        let url = "ajax/user/create";

        if("id" in self.props.match.params) {
            self.state.user_create = false;
            url = "ajax/user/create/" + self.props.match.params.id;
        }

        axios.get(url)
        .then(function(response) {
            self.state.shuser_form.first_name = response?.data.view.first_name;
            self.state.shuser_form.last_name = response?.data.view.last_name;
            self.state.shuser_form.company = response?.data.view.company;
            self.state.shuser_form.title = response?.data.view.title;
            self.state.shuser_form.email = response?.data.view.email;
            self.state.shuser_form.email_confirm = response?.data.view.email;
            self.state.shuser_form.phone = response?.data.view.phone;
            self.state.shuser_form.oem_id = response?.data.view.oem_id;
            self.state.shuser_form.sh_id = response?.data.view.sh_id;
            self.state.shuser_form.vmh_id = response?.data.view.vmh_id;

            self.setState({
                shuser_details: response?.data.view,
                action: response?.data.action,
                loading_page: false,
            })
        })
        .catch(function(error) {
            if(error.response?.status == 401){
                showStatusMsg(error.response?.data.error);
            } else if(error.response?.status == 422) {
                var error_message = "";

                $.each(error.response?.data.errors, function (index, element) {
                    error_message += element + '<br />';
                });

                showStatusMsg(error_message);
            } else {
                showStatusMsg("Requested information not found");
            }

            if (self.props.closeModal) self.props.closeModal();
        })
    }

    updateForm(event) {
        const target = event.target;
        const value = target.type === 'checkbox' ? target.checked : target.value;
        const name = target.name;
        var shuser_form = this.state.shuser_form;
        shuser_form[name] = value;

        this.setState({
            shuser_form: shuser_form
        });
    }

    updateSelect(option) {
        var shuser_form = this.state.shuser_form;
        shuser_form[option.name] = option.value;

        if(option.name == "role") {
            this.state.selected_role = option;
        } else if(option.name == "oem_id") {
            this.state.selected_oem = option;
            this.loadDivisions(option.value);
        } else if(option.name == "vmh_id") {
            this.state.selected_vmh = option;
            this.loadTypesAndRoles();
        } else if(option.name == "sh_id") {
            this.state.selected_sh = option;
            if(this.state.shuser_form.vmh_id == -9)
            {
                this.loadVMHs(option.value);
            }
            else
            {
                this.loadTypesAndRoles();
            }
        } else if(option.name == "type") {
            this.state.selected_type = option;
        }

        this.setState({
            shuser_form: shuser_form
        });
    }

    loadDivisions(id) {
        axios.post('/ajax/stakeholder/' + id + '/options', {
                'filter': 'admin',
            })
            .then((response) => {
                let newState = Object.assign({}, this.state);
                newState.shuser_details.divisions = response?.data.stakeholders;

                if(newState.selected_sh != null)
                {
                    newState.selected_sh = null;
                    newState.shuser_form["sh_id"] = null;
                }

                if(newState.selected_vmh != null)
                {
                    newState.selected_vmh = null;
                    newState.shuser_form["vmh_id"] = null;
                }

                if(newState.selected_type != null)
                {
                    newState.selected_type = null;
                    newState.shuser_form["type"] = null;
                }

                if(newState.selected_role != null)
                {
                    newState.selected_role = null;
                    newState.shuser_form["role"] = null;
                }

                this.setState(newState);
            })
            .catch(function(error) {
                if(error.response?.status == 401){
                    showStatusMsg(error.response?.data.error);
                } else if(error.response?.status == 422) {
                    var error_message = "";

                    $.each(error.response?.data.errors, function (index, element) {
                        error_message += element + '<br />';
                    });

                    showStatusMsg(error_message);
                } else {
                    showStatusMsg("Requested information not found");
                }
            })
    }

    loadVMHs(id) {
        axios.post('/ajax/vmh/' + id + '/options', {
                'filter': 'admin',
            })
            .then((response) => {
                let newState = Object.assign({}, this.state);
                newState.shuser_details.vmhs = response?.data.vmhs;

                if(newState.selected_vmh != null)
                {
                    newState.selected_vmh = null;
                    newState.shuser_form["vmh_id"] = null;
                }

                if(newState.selected_type != null)
                {
                    newState.selected_type = null;
                    newState.shuser_form["type"] = null;
                }

                if(newState.selected_role != null)
                {
                    newState.selected_role = null;
                    newState.shuser_form["role"] = null;
                }

                this.setState(newState);
            })
            .catch(function(error) {
                if(error.response?.status == 401){
                    showStatusMsg(error.response?.data.error);
                } else if(error.response?.status == 422) {
                    var error_message = "";

                    $.each(error.response?.data.errors, function (index, element) {
                        error_message += element + '<br />';
                    });

                    showStatusMsg(error_message);
                } else {
                    showStatusMsg("Requested information not found");
                }
            })
    }

    loadTypesAndRoles() {
        axios.post('/ajax/typeandroles/available_options', {
                'oem_id': this.state.shuser_form.oem_id,
                'sh_id': this.state.shuser_form.sh_id,
                'vmh_id': this.state.shuser_form.vmh_id
            })
            .then((response) => {
                let newState = Object.assign({}, this.state);
                newState.shuser_details.selectable_types = response?.data.types;
                newState.shuser_details.selectable_roles = response?.data.roles;

                if(newState.selected_type != null)
                {
                    newState.selected_type = null;
                    newState.shuser_form["type"] = null;
                }

                if(newState.selected_role != null)
                {
                    newState.selected_role = null;
                    newState.shuser_form["role"] = null;
                }
                
                this.setState(newState);
            })
            .catch(function(error) {
                if(error.response?.status == 401){
                    showStatusMsg(error.response?.data.error);
                } else if(error.response?.status == 422) {
                    var error_message = "";

                    $.each(error.response?.data.errors, function (index, element) {
                        error_message += element + '<br />';
                    });

                    showStatusMsg(error_message);
                } else {
                    showStatusMsg("Requested information not found");
                }
            })
    }

    submitForm(e, settings_type) {
        e.preventDefault();
        var self = this;

        let url = "ajax/user";

        if("id" in self.props.match.params) {
            url = "ajax/user/" + self.props.match.params.id;
        }

        axios({
            method: 'post',
            url: url,
            data: this.state.shuser_form,
            config: { headers: {'Content-Type': 'multipart/form-data' }}
        })
        .then((response) => {
            //handle success
            if(self.props.match.url.split("/")[1] === "administration") {
                axios({
                    method: 'post',
                    url: '/ajax/users',
                    data: { search_term: $("#searchbar").val(),
                            vmh: $("input[name='vmh[]']:checked").map(function () { return this.value; }).get().join('#'), 
                            sh: $("input[name='sh[]']:checked").map(function () { return this.value; }).get().join('#'), 
                            company: $("input[name='company[]']:checked").map(function () { return this.value; }).get().join('#'), 
                            title: $("input[name='title[]']:checked").map(function () { return this.value; }).get().join('#'), 
                            status: $("input[name='status[]']:checked").map(function () { return this.value; }).get().join('#'), 
                            role: $("input[name='role[]']:checked").map(function () { return this.value; }).get().join('#'), 
                            type: $("input[name='type[]']:checked").map(function () { return this.value; }).get().join('#'), 
                            sort_filter: $("#sort_filter").val(),
                            sort_direction: $("#sort_direction").val(),
                        }
                })
                .then(function(response) {
                    self.props.dispatch(setList("SET_SHUSER_LIST", response?.data.data.data))
                })
                .catch(function(error) {
                    if(!("response" in error)) {
                        showStatusMsg("Requested information not found");
                    } else if(error.response?.status == 401){
                        showStatusMsg(error.response?.data.error);
                    } else if(error.response?.status == 422) {
                        var error_message = "";

                        $.each(error.response?.data.errors, function (index, element) {
                            error_message += element + '<br />';
                        });

                        showStatusMsg(error_message);
                    } else {
                        showStatusMsg("Requested information not found");
                    }
                })
            }

            showStatusMsg(response?.data.message, 'success');
            if (self.props.closeModal) self.props.closeModal();
        })
        .catch(function(error) {
            //handle error
            if(error.response?.status == 401){
                showStatusMsg(error.response?.data.error);
            } else if(error.response?.status == 422) {
                var error_message = "";

                $.each(error.response?.data.errors, function (index, element) {
                    error_message += element + '<br />';
                });

                showStatusMsg(error_message);
            } else {
                showStatusMsg("Requested information not found");
            }
        });
    }

    render(props) {
        if(!this.state.loading_page) {
            return (
                <div className = "reveal" id = "settings-overlay" style={{display: "block",top:"0"}}>
                    <div className = "card">
                        <div className = "card-divider">
                            <span className = "card-header-title">{ !this.state.user_create ? "Add Role" : "Add User"}</span>
                            <button className="close-button" data-close aria-label='Close modal' type='button' onClick={this.props.closeModal}>
                                <span aria-hidden='true'>&times;</span>
                            </button>
                        </div>
                        <div className = "card-divider">
                        {
                            this.state.shuser_details.oem_id == -9 || this.state.shuser_details.sh_id == -9 ?
                                <div className = "row expanded collapse">
                                    {
                                        this.state.shuser_details.oem_id == -9 ?
                                            <div className = "columns large-6 medium-6 small-12">
                                                <label>OEM <span className = "red-alert">*</span>
                                                    <Select 
                                                        options={
                                                            !this.state.loading_page ?
                                                                this.state.shuser_details.oems.map((oem, i) =>
                                                                    ({
                                                                        label: oem.option, value: oem.value, name: "oem_id"
                                                                    })
                                                                )
                                                            :
                                                            ([{
                                                                label:'N/A', value:''
                                                            }])
                                                        } 
                                                        onChange={this.updateSelect}
                                                        value={this.state.selected_oem}
                                                        style={{width: "95%",height:'36px'}}
                                                        className="form-95"
                                                        classNamePrefix="react_select" />
                                                </label>
                                            </div>
                                        :
                                            null
                                    }
                                    {
                                        this.state.shuser_details.sh_id == -9 ?
                                            <div className = "columns large-6 medium-6 small-12">
                                                <label><Trans>Pool </Trans> <span className = "red-alert">*</span>
                                                    <Select 
                                                        options={
                                                            !this.state.loading_page ?
                                                                this.state.shuser_details.divisions.map((sh, i) =>
                                                                    ({
                                                                        label: sh.option, value: sh.value, name: "sh_id"
                                                                    })
                                                                )
                                                            :
                                                            ([{
                                                                label:'N/A', value:''
                                                            }])
                                                        } 
                                                        onChange={this.updateSelect}
                                                        value={this.state.selected_sh}
                                                        style={{width: "95%",height:'36px'}}
                                                        className="form-95"
                                                        classNamePrefix="react_select" />
                                                </label>
                                            </div>
                                        :
                                            null
                                    }
                                </div>
                            :
                                null
                        }
                        {
                            this.state.shuser_details.vmh_id == -9 ?
                                <div className = "row expanded collapse">
                                    <div className = "columns large-6 medium-6 small-12">
                                        <label>Facility <span className = "red-alert">*</span>
                                            <Select 
                                                options={
                                                    !this.state.loading_page ?
                                                        this.state.shuser_details.vmhs.map((vmh, i) =>
                                                            ({
                                                                label: vmh.option, value: vmh.value, name: "vmh_id"
                                                            })
                                                        )
                                                    :
                                                    ([{
                                                        label:'N/A', value:''
                                                    }])
                                                } 
                                                onChange={this.updateSelect}
                                                value={this.state.selected_vmh}
                                                style={{width: "95%",height:'36px'}}
                                                className="form-95"
                                                classNamePrefix="react_select" />
                                        </label>
                                    </div>
                                </div>
                            :
                                null
                        }
                            <div className = "row expanded collapse">
                                <div className = "columns large-6 medium-6 small-12">
                                    <label><Trans>User Type</Trans> <span className = "red-alert">*</span>
                                        <Select 
                                            options={
                                                !this.state.loading_page ?
                                                    Object.keys(this.state.shuser_details.selectable_types).map((type, i) =>
                                                        ({
                                                            label: this.state.shuser_details.selectable_types[type], value: type, name: "type"
                                                        })
                                                    )
                                                :
                                                ([{
                                                    label:'N/A', value:''
                                                }])
                                            } 
                                            onChange={this.updateSelect}
                                            value={this.state.selected_type}
                                            style={{width: "95%",height:'36px'}}
                                            className="form-95"
                                            classNamePrefix="react_select" />
                                    </label>
                                </div>
                                <div className = "columns large-6 medium-6 small-12">
                                    <label><Trans>User Role</Trans> <span className = "red-alert">*</span>
                                        <Select 
                                            options={
                                                !this.state.loading_page ?
                                                    Object.keys(this.state.shuser_details.selectable_roles).map((role, i) =>
                                                        ({
                                                            label: this.state.shuser_details.selectable_roles[role], value: role, name: "role"
                                                        })
                                                    )
                                                :
                                                ([{
                                                    label:'N/A', value:''
                                                }])
                                            } 
                                            onChange={this.updateSelect}
                                            value={this.state.selected_role}
                                            style={{width: "95%",height:'36px'}}
                                            className="form-95"
                                            classNamePrefix="react_select" />
                                    </label>
                                </div>
                            </div>
                        </div>
                        <div className="tabs-content no-border" data-tabs-content="settings-tab">
                            <div className="tabs-panel is-active" id="panel1">
                                <div className = "row expanded collapse">
                                    <div className = "columns large-6 medium-6 small-12">
                                        <label><Trans>First Name</Trans> <span className = "red-alert">*</span>
                                            <input type = "text" name = "first_name" className = "form-95" defaultValue={this.state.shuser_form.first_name} readOnly={!this.state.user_create} onChange={this.updateForm} />
                                        </label>
                                    </div>
                                    <div className = "columns large-6 medium-6 small-12">
                                        <label><Trans>Last Name</Trans> <span className = "red-alert">*</span>
                                            <input type = "text" name = "last_name" defaultValue={this.state.shuser_form.last_name} readOnly={!this.state.user_create} onChange={this.updateForm}/>
                                        </label>
                                    </div>
                                </div>
                                <div className = "row expanded collapse">
                                    <div className = "columns large-6 medium-6 small-12">
                                        <label><Trans>Company</Trans> 
                                            <input type = "text" name = "company" className = "form-95" defaultValue={this.state.shuser_form.company} readOnly={!this.state.user_create} onChange={this.updateForm}/>
                                        </label>
                                    </div>
                                    <div className = "columns large-6 medium-6 small-12">
                                        <label><Trans>Title</Trans>
                                            <input type = "text" name = "title" defaultValue={this.state.shuser_form.title} readOnly={!this.state.user_create} onChange={this.updateForm} />
                                        </label>
                                    </div>
                                </div>
                                <div className = "row expanded collapse">
                                    <div className = "columns large-6 medium-6 small-12">
                                        <label><Trans>Email</Trans> <span className = "red-alert">*</span>
                                            <input type = "text" name = "email" className = "form-95" defaultValue={this.state.shuser_form.email} readOnly={!this.state.user_create} onChange={this.updateForm}/>
                                        </label>
                                    </div>
                                    {
                                        !this.state.user_create ?
                                            <div className = "columns large-6 medium-6 small-12">
                                                <label><Trans>Phone</Trans>
                                                    <input type = "text" name = "phone" key={this.state.settings_type + "_phone"} defaultValue={this.state.shuser_form.phone} readOnly={!this.state.user_create} onChange={this.updateForm} />
                                                </label>
                                            </div>
                                        :
                                            <div className = "columns large-6 medium-6 small-12">
                                                <label><Trans>Email Confirm</Trans> <span className = "red-alert">*</span>
                                                    <input type = "text" name = "email_confirm" key={this.state.settings_type + "_email_confirm"} defaultValue={this.state.shuser_form.email_confirm} readOnly={!this.state.user_create} onChange={this.updateForm}/>
                                                </label>
                                            </div>
                                    }
                                </div>
                                <div className = "row expanded collapse">
                                    {
                                        this.state.user_create || this.state.edit ?
                                            <div className = "columns large-6 medium-6 small-12">
                                                <label><Trans>Phone</Trans>
                                                    <input type = "text" name = "phone" key={this.state.settings_type + "_phone"} className = "form-95" defaultValue={this.state.shuser_form.phone} readOnly={!this.state.user_create} onChange={this.updateForm} />
                                                </label>
                                            </div>
                                        :
                                            null
                                    }
                                </div>
                            </div>
                        </div>
                        <div className = "card-button-section">
                            <div className = "button-group float-right">
                                <a className = "button primary" onClick={this.submitForm}><Trans>Add</Trans> { !this.state.user_create ? "Role" : "User"}</a>
                            </div>
                        </div>
                    </div>
                </div>
            )
        } else {
            return (
                <LoadingIcon />
            );
        }
    }
}

const mapStateToProps = store => ({
    userSession: store.userSession,
    data: store.data
})

export default connect(mapStateToProps)(SHUser)